<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success=false"
    >{{alert_success_message}}</b-alert>

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error=false"
    >{{alert_error_message}}</b-alert>

    <b-container fluid>
      <b-breadcrumb class="mt-3 mb-3" :items="breadcrumb_items"/>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-select
              size="sm"
              v-model="search_criteria.status_selected"
              :options="status_options"
            />
          </b-col>
          <b-col cols="2" class="pl-0 pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Tracking#"
              v-model="search_criteria.keyword"
            ></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button class="btn-action" size="sm" variant="info" @click="onSearch">
              <font-awesome-icon class="mr-1" icon="search"/>Search
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div class="search_bar mb-3">
        <b-row>
          <b-col cols="2" class="pr-1">
            <b-form-input
              id="input-small"
              size="sm"
              type="text"
              placeholder="Tracking#"
              v-model="assign_tracking_number"
              v-on:keyup.enter="onAssignTracking"
            ></b-form-input>
          </b-col>
          <b-col class="text-left p-0">
            <b-button
              class="btn-action"
              size="sm"
              variant="info"
              @click="onAssignTracking"
            >Assign to Driver</b-button>
          </b-col>
        </b-row>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table responsive small outlined striped hover :items="items" :fields="fields">

        <template v-slot:cell(status)="data">
          {{data.item.status}}
          <span v-if="data.item.status_reason">- {{data.item.status_reason}}</span>
          <span v-if="data.item.other_reason">
            <br>
            [{{data.item.other_reason}}]
          </span>
        </template>

        <template v-slot:cell(pod_image)="data">
          <a
            v-if="data.item.pod_image"
            :href="data.item.pod_image"
            target="_blank"
          >{{data.item.pod_type}}</a>
          <span v-if="!data.item.pod_image">/</span>
        </template>

        <template v-slot:cell(schedule_date)="data">{{displayDate(data.item.schedule_date)}}</template>

        <template
          slot="reschedule_delivery_date"
          slot-scope="data"
        >{{displayDate(data.item.reschedule_delivery_date)}}</template>

        <!-- <template slot="updated_at" slot-scope="data">{{displayDateTime(data.item.schedule_date)}}</template> -->
        <template v-slot:cell(action)="data">
          <b-button
            class="btn-action"
            size="sm"
            variant="info"
            @click.stop="returnTracking(data.item)"
          >
            <font-awesome-icon class="mr-1" icon="undo"/>Returned
          </b-button>

          <b-button
            :disabled="data.item.status != 'Returned to Warehouse'"
            class="btn-action"
            size="sm"
            variant="info"
            @click.stop="showModal_reschedule_tracking(data.item)"
          >
            <font-awesome-icon class="mr-1" icon="calendar-alt"/>Reschedule
          </b-button>
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-modal ref="modal_reschedule_tracking" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Tracking#: {{updating_item.tracking_number}}</b-col>
          </b-row>

          <b-row>
            <b-col>
              <label>Reschedule:</label>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="auto" class="pr-0">
              <b-form-radio-group
                id="btnradios2"
                buttons
                button-variant="outline-info"
                v-model="reschedule_type_selected"
                :options="reschedule_type_options"
                name="radioBtnOutline"
              />
            </b-col>
            <b-col class="pl-1">
              <b-form-input id="reschedule_delivery_date" type="date" v-model="reschedule_date"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_reschedule_tracking">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="rescheduleTracking()">Confirm</b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";

const fields = [
  {
    key: "tracking_number",
    label: "Tracking#"
  },
  {
    key: "barcode",
    label: "Barcode"
  },
  {
    key: "attention",
    label: "Attention"
  },
  {
    key: "phone",
    label: "Phone"
  },
  {
    key: "status",
    label: "Status"
  },
  {
    key: "schedule_date",
    label: "Scheduled Date"
  },
  {
    key: "reschedule_delivery_date",
    label: "Rescheduled Date"
  },
  {
    key: "pod_image",
    label: "POD Record"
  },
  {
    key: "updated_at",
    label: "Last Updated"
  },
  {
    key: "action",
    label: "Action"
  }
];

export default {
  name: "DriverTrackings",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      breadcrumb_items: [
        {
          text: "Drivers",
          to: { name: "drivers" }
        },
        {
          text: "Trackings",
          active: true
        }
      ],
      driver: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      assign_tracking_number: "",
      updating_item: false,
      search_criteria: {
        keyword: "",
        status_selected: null
      },
      status_options: [
        {
          value: null,
          text: "All Status"
        },
        {
          value: "Pending",
          text: "Pending"
        },
        {
          value: "In-Transit",
          text: "In-Transit"
        },
        {
          value: "Returning to GOLS Warehouse",
          text: "Returning to GOLS Warehouse"
        },
        {
          value: "Successful Delivery",
          text: "Successful Delivery"
        },
        {
          value: "Returned to Warehouse",
          text: "Returned to Warehouse"
        }
      ],
      reschedule_type_selected: "before",
      reschedule_type_options: [
        {
          value: "before",
          text: "before"
        },
        {
          value: "on",
          text: "on"
        },
        {
          value: "after",
          text: "after"
        }
      ],
      reschedule_date: moment().format("YYYY-MM-DD"),
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message : "",
    };
  },
  async created() {
    await this.getDriver();
    await this.getTrackings();
    this.initialized = true;
  },
  mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getDriver() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "driver_get.php",
        data: {
          id: this.$route.params.id
        }
      });
      if (response.data.drivers) {
        this.driver = response.data.drivers[0];
      }
    },

    async getTrackings() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          search_criteria: this.search_criteria,
          driver_id: this.$route.params.id,
          user_id: this.$store.state.user_obj.user_id,
        }
      });
      this.items = response.data.trackings;
      this.total_rows = parseInt(response.data.total_rows);
      this.loader.hide();
    },

    onSearch() {
      this.getTrackings();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getTrackings();
    },

    showModal_reschedule_tracking(item) {
      this.updating_item = item;
      this.reschedule_type_selected = "before";
      this.reschedule_date = moment().format("YYYY-MM-DD");
      this.$refs.modal_reschedule_tracking.show();
    },

    hideModal_reschedule_tracking() {
      this.$refs.modal_reschedule_tracking.hide();
    },

    returnTracking(item) {
      this.updateTracking(item, "Returned to Warehouse", null, null);
    },

    rescheduleTracking() {
      this.updateTracking(
        this.updating_item,
        "Rescheduled",
        this.reschedule_type_selected,
        this.reschedule_date
      );
    },

    async getTrackingByTrackingId() {},

    async onAssignTracking() {
      let _this = this;
      this.assign_tracking = false;
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_detail_get.php",
        data: {
          tracking_id: this.assign_tracking_number,
          by_tracking_number : true
        }
      });

      if (response.data.tracking) {
        _this.doAssignTracking(response.data.tracking);
      } else {
        this.alert_error_message = `Tracking #${this.assign_tracking_number} not found.`;
        this.showAlert_error = true;
        setTimeout(() => {
          this.showAlert_error = false;
          this.alert_error_message = "";
        }, 3000);
      }
    },

    async doAssignTracking(assign_tracking){
      let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "tracking_pickup.php",
          data: {
            tracking_id: assign_tracking.id,
            user_id: this.$route.params.id
          }
        });

        if (response.data.status == "success") {
          this.alert_success_message = `Tracking #${
            this.assign_tracking_number
          } Assigned Successfully.`;
          this.showAlert_success = true;
          setTimeout(() => {
            this.showAlert_success = false;
            this.alert_success_message = "";
          }, 3000);
          this.getTrackings();
        }
    },

    async updateTracking(
      tracking_obj,
      status,
      reschedule_delivery_type,
      reschedule_delivery_date
    ) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_update.php",
        data: {
          id: tracking_obj.id,
          status: status,
          reschedule_delivery_type: reschedule_delivery_type,
          reschedule_delivery_date: reschedule_delivery_date,
          user_id: "3"
        }
      });

      if (response.data.status == "success") {
        this.alert_success_message = `Tracking #${tracking_obj.tracking_number} Update Successfully.`;
        this.showAlert_success = true;
        setTimeout(() => {
          this.showAlert_success = false;
          this.alert_success_message = "";
        }, 3000);
        this.getTrackings();
      } else {
      }

      this.$refs.modal_reschedule_tracking.hide();
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/DriverTrackings.vue